/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubRegionDetail {
    getFixupPrototypeFunction() { return AwsSecurityHubRegionDetail.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubRegionDetail>): AwsSecurityHubRegionDetail {
        let obj = Object.assign(new AwsSecurityHubRegionDetail(), model);
        AwsSecurityHubRegionDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubRegionDetail>): AwsSecurityHubRegionDetail {
        if (!model) return null;
        return AwsSecurityHubRegionDetail.newInstance(<AwsSecurityHubRegionDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubRegionDetail) {
        if (!obj) return;

        models.AwsSecurityHubRegionDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubRegionDetail): boolean {
        Object.setPrototypeOf(obj, AwsSecurityHubRegionDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * AWS security hub region
     */
    region: string;

    /**
     * Permission validation status
     */
    status: models.AwsSecurityHubPermissionValidationStatus;

    /**
     * AWS security hub status message
     */
    message: string;

}
